<script setup lang="ts">
import { useTheme } from '@/composables/useTheme';

// Initialize theme on app load to prevent flash of wrong theme
useTheme();
</script>

<template>
  <RouterView />
</template>
